import React, { Component } from "react"
import { Button, Form, FormInput, Spinner } from "elemental"
import serialize from "form-serialize"
import { Card, Image } from "semantic-ui-react"
import swal from "sweetalert"
import Attachments from "theme/components/Attachments/Attachments"
import shop from "shop/shop"

export default class FormCMS extends Component {
  state = {
    loading : false,
    error   : false,
    page    : false,
    success : false,
    redirect: false,
    files   : [],
    filePreviews: [],
  }

  componentDidMount() {
    let slug = this.props.slug
    this.load( slug )
  }

  componentWillReceiveProps( props ) {
    let slug = this.props.slug

    console.log( `received slug`, slug )
    if ( this.state.slug === slug ) return
    this.load( slug )
  }

  load( slug ) {
    this.setState( { slug, loading: true } )
    shop.form( slug )
      .then( res => {
        console.log( `res`, res )
        return res
      } )
      .then( pages => pages[ 0 ] )
      .then( ( page ) => {
        console.log( `loaded page`, page )
        this.setState( { page, loading: false } )
      } )
      .catch( error => {
        this.setState( { error } )
      } )
  }

  onSubmit = ( e ) => {
    if ( this.state.loading ) return
    const form = serialize( e.target, { hash: true } )
    //onSubmit({form})
    console.info( `submitting form`, form )
    this.setState( { form, loading: true } )
    shop.service.request( this.state.slug, form )
      .then( response => {
        console.log( `response`, response )
        if ( response.status > 200 ) {
          throw(new Error( response.statusText ))
        }
        this.setState( { response, loading: false, success: true } )
        if ( this.props.onSuccess ) {
          this.props.onSuccess()
        }
        console.log( `Form Response`, response )
      } )
      .catch( response => {
        this.setState( { response, loading: false, success: false, error: true } )
        window.swal( "Fehler", "Fehler bei der Übertragung: " + response, "error" )
      } )
    e.preventDefault()
    return false
  }

  render() {
    let { page, form, response, loading } = this.state
    if ( !page || !page.acf ) return null
    let { allowUploads } = page.acf
    return (
      <div className=" pt4 pl2 pr2">
        <div className="">
          <Form className="Form--cms" onSubmit={this.onSubmit}>
            {page ? <div dangerouslySetInnerHTML={{ __html: page.content.rendered }}></div> : <div>Lade Formular</div>}
            {allowUploads &&
            <div className="pt0 pb5">
              <Attachments accept=".jpg,.jpeg,.png,.doc,.pdf,.gif"
                           onChange={( { files } ) => {
                             this.setState( { loading: true } )
                             console.log( `uploading files`, files )
                             if ( files ) {
                               shop.service.params( files )
                                 .then( async res => {
                                   if ( res.status >= 300 ) {
                                     let text = await res.text()
                                     throw Error( text )
                                   }
                                   return res.text()
                                 } )
                                 .then( response => {
                                   console.log( `adding file`, response )
                                   let fileList = [...this.state.files, response]
                                   this.setState( { loading: false, files:[fileList[0]],
                                     filePreviews: [...files] } )
                                 } )
                                 .catch( error => {
                                   console.error( "Error Uploading File:", error )
                                   swal( "Fehler", `Ihre Datei konnte nicht gespeichert werden: \n\t ${error}`, "error" )
                                   this.setState( { loading: false } )
                                 } )
                             }
                           }}>
                <Button>Datei auswählen</Button>


              </Attachments>
            </div>}

           <div className="pv3">

             {(this.state.files.length > 0) && <div className="">
               <h3>Ihre Anhänge </h3>
               <Image.Group size="tiny">
                 {this.state.filePreviews.map( file =>  <Image key={file.name} src={file.preview}/> )}
               </Image.Group>

               {this.state.files.map( file => <FormInput readOnly hidden key={file} value={file} name="attachment"/> )}
             </div>}
           </div>

            <div className="FormField">
              <Button disabled={loading} submit type="primary">{loading ? <Spinner/> : null} Absenden</Button>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/theme/components/Form/FormCMS.js